/**
 * タイトルを表します。
 */
export class CommonMsgConst {
  // 課題No18 メッセージ定数ファイルは利用不可
  /**
  public static readonly N401201: string = 'メールアドレスが一致しません。';
  public static readonly N401204: string = '郵便番号は数字と"-"半角ハイフォン以外は入力出来ません。';
  public static readonly N401205: string = '郵便番号は７桁以上を入力してください。';
  public static readonly N401206: string = '郵便番号に"-"半角ハイフォンがありません。';
  public static readonly N401207: string = '"-"半角ハイフォンの位置が違います。';
  public static readonly N403201: string = 'ユーザＩＤは６桁以上を入力してください。';

  public static readonly N406101: string = '連続して入力を間違えたため、当日中は再発行依頼ができません。';
  public static readonly N406102: string = 'いずれかの入力内容が間違っています。';
  public static readonly N406103: string = 'NichihaPortNetでのパスワード再発行ができないユーザです。基幹システム管理者にお問い合わせください。';
  public static readonly N406104: string = 'パスワード再発行メールの送信に失敗しました。';

  public static readonly N501101: string = 'ログイン情報に誤りがあります。';
  public static readonly N501102: string = 'パスワードの有効期限が切れています。';

  public static readonly N501201: string = '認証試行回数を超えたか、有効期限切れの認証キーのため、再度ログインからお願いします。';
  public static readonly N501202: string = 'ニチハポートネットにご登録された電話番号宛に認証キーを送付いたしました。\n携帯をご覧になり、当画面に認証キーを入力し、「認証キーを送る」をクリックしてください。';
  public static readonly N501203: string = '認証キーが間違っています。再度入力をお願いします。';

  public static readonly N000001: string = '{0}は必須{1}項目です。{2}してください。';
  public static readonly N000002: string = '{0}は{1}で入力してください。';
  public static readonly N000003: string = '{0}は{1}で入力してください。';
  public static readonly N000011: string = '検索条件に合うデータは見つかりませんでした。';
  public static readonly N000016: string = 'メールアドレスが不正です。[{0}]';
  public static readonly N000020: string = '{0}に利用できない文字が含まれております。';
  public static readonly N000018: string = '{0}を入力してください。';

  public static readonly N999101: string = '背景の赤い項目がエラーです。確認してください。'
  public static readonly N999102: string = '対象データがありません。';
  **/
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/const/common-message-const.ts